import React from 'react';

export default function Toggle({ checked, onChange, label }) {
  return (
    <div
      className="toggle-wrap"
      onClick={() => onChange(!checked)}
      role="switch"
      aria-checked={checked}
      aria-label={label}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!e.repeat) onChange(!checked);
        }
      }}
    >
      <div className={`toggle-track ${checked ? 'on' : 'off'}`} />
      <div className={`toggle-thumb ${checked ? 'on' : 'off'}`} />
    </div>
  );
}
